<template>
    <section>
        <b-modal :active.sync="showFeedbackModal"
        		has-modal-card
            	trap-focus
                aria-role="dialog"
                aria-modal
                scroll="keep">
    		<form action="">
                <div class="modal-card" style="width: 320px">
                    <header class="modal-card-head">
                        <p class="modal-card-title">Feedback and questions</p>
                    </header>

                    <section class="modal-card-body">
						<b-field label="Name">
				            <b-input v-model="name"></b-input>
				        </b-field>

				        <b-field label="Organization">
				            <b-input v-model="organization"></b-input>
				        </b-field>

						<b-field label="Feedback">
				            <b-input v-model="feedback.message" maxlength="400" type="textarea"></b-input>
				        </b-field>

				        <b-field label="Email">
				            <b-input v-model="email" type="email"></b-input>
				        </b-field>
                    </section>

                    <footer class="modal-card-foot">
                        <button class="button is-primary is-fullwidth" type="button" @click="sendFeedback">Send</button>
                    </footer>
                </div>
            </form>
    	</b-modal>
    </section>
</template>

<script>
	export default {
		name: 'FeedbackModal',

		data() {
			return {
				feedback: {
					message: null,
					email: null,
					toolnaam: 'traffic-movies',
					organization: null,
					naam: null
				}
			}
		},

		computed: {
			showFeedbackModal: {
				get () {
					return this.$store.getters.showFeedbackModal
				},
				set () {
					this.$store.commit('toggleFeedbackModal')
				}
			},

			email: {
				get () {
					this.feedback.email = this.$store.getters.showEmail
					return this.$store.getters.showEmail
				},
				set (value) {
					this.feedback.email = value
				}
			},

			name: {
				get () {
					this.feedback.naam = this.$store.getters.showName
					return this.$store.getters.showName
				},
				set (value) {
					this.feedback.naam = value
				}
			},

			organization: {
				get () {
					this.feedback.organization = this.$store.getters.showOrganization
					return this.$store.getters.showOrganization
				},
				set (value) {
					this.feedback.organization = value
				}
			}
		},

		methods: {
			sendFeedback() {
				this.axios
					.post("https://o1lmo6vhok.execute-api.eu-central-1.amazonaws.com/api/feedback", this.feedback)
					.then(response => {
						this.$buefy.dialog.alert('Thank you for your feedback!')
					})
	                .catch(err => {
	                    this.$buefy.dialog.alert({
	                        title: 'Error',
	                        message: err.message,
	                        type: 'is-danger',
	                        hasIcon: true
	                    })
	                })
					.finally( () => {
						this.feedback.feedback = null
						this.$store.commit('toggleFeedbackModal')
					})

			}
		}
	}
</script>